__turbopack_context__.v({
  "action": "styles-module-scss-module__AsluGG__action",
  "deleting_note": "styles-module-scss-module__AsluGG__deleting_note",
  "note": "styles-module-scss-module__AsluGG__note",
  "note_mast": "styles-module-scss-module__AsluGG__note_mast",
});
